import BaseAPIClient from '../base/BaseAPIClient';

export default class PayrollClient extends BaseAPIClient {
  payoutExport(payoutExportId) {
    return this._get("v2/counselors/payroll/payout", { payoutExportId });
  }
  payoutExports(pageToken) {
    return this._get("v2/counselors/payroll/payouts", { pageToken });
  }
  adjust(counselorId, adjustmentAmount, explanation, payoutImmediately) {
    return this._post("v2/counselors/payroll/adjust", { 
      counselorId, 
      adjustmentAmount,
      explanation, 
      payoutImmediately
    });
  }
  setPayroll(counselorId, payrollTier, paidAs) {
    return this._post("v2/counselors/payroll", { 
      counselorId, 
      payrollTier, 
      paidAs 
    });
  }
  getPayroll(counselorId) {
    return this._get("v2/counselors/payroll", { counselorId });
  }
}